import { render } from "./MenuSet.vue?vue&type=template&id=33317e48&scoped=true"
import script from "./MenuSet.vue?vue&type=script&lang=js"
export * from "./MenuSet.vue?vue&type=script&lang=js"

import "./MenuSet.vue?vue&type=style&index=0&id=33317e48&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33317e48"]])

export default __exports__